import type { ScatterPlotDatum, ScatterPlotLayerProps } from '@nivo/scatterplot';
import { truncateScatterLabel } from './analyticsHelpers';

export interface ScatterPlotPointDatum extends ScatterPlotDatum {
  entityId: string;
  showLabel?: boolean;
}

export function ScatterPlotLabelsLayer({ nodes }: ScatterPlotLayerProps<ScatterPlotPointDatum>) {
  return (
    <g className="gda-analytics-scatter-labels">
      {nodes
        .filter(node => node.data.showLabel)
        .map(node => (
          <text
            key={node.id}
            x={node.x}
            y={node.y - 12}
            textAnchor="middle"
            className="gda-analytics-scatter-label"
          >
            {truncateScatterLabel(node.data.entityId)}
          </text>
        ))}
    </g>
  );
}
